module.exports = __webpack_public_path__ + "static/media/enkel.a3e556f6.mp3";